import { render, staticRenderFns } from "./tmAudioBorder.vue?vue&type=template&id=0a81fcca&"
import script from "./tmAudioBorder.vue?vue&type=script&lang=js&"
export * from "./tmAudioBorder.vue?vue&type=script&lang=js&"
import style0 from "./tmAudioBorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports